import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Adv2Config } from '../../utils/adv2-config';

@Injectable({ providedIn: 'root' })
export class Adv2ConfigService {
  constructor(private http: HttpClient) {}

  getConfig(token: string): Observable<Adv2Config> {
    const url = `${environment.kpHost}/adv2/config`;
    const authHeader = { headers: { Authorization: 'bearer ' + token } };
    return this.http.get<Adv2Config>(url, authHeader).pipe(map((configExchange: any) => configExchange.config));
  }
}
